@if (loading$ | async) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

<form class="login" [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()">
  <img
    class="client-logo"
    src="assets/svg/fullyops-logo-white.svg"
    alt="FullyOps Logo"
  />
  <br />
  @if (!formSent) {
    <header>
      <h2>{{ 'translation:forgotPassword' | i18nextCap }}</h2>
      <p>{{ 'translation:forgotPasswordText' | i18nextCap }}</p>
    </header>
    <mat-form-field appearance="outline">
      <mat-label>{{ 'validation:username' | i18nextCap }}</mat-label>
      <input matInput type="text" name="username" formControlName="username" />
      @if (this.forgotPasswordForm.controls.username.hasError('required')) {
        <mat-error>{{
          'validation:youMustEnterAValue' | i18nextCap
        }}</mat-error>
      }
      @if (this.forgotPasswordForm.controls.username.hasError('userNotFound')) {
        <mat-error>{{ 'validation:userNotFound' | i18nextCap }}</mat-error>
      }
    </mat-form-field>
    <div class="form-group">
      <button
        class="btn-flip"
        attr.data-front="{{ 'send' | i18nextCap }}"
        attr.data-back="{{ 'submit' | i18nextCap }}"
      ></button>
      <p>
        {{ 'translation:justRemembered' | i18nextCap }}
        <a routerLink="/login">{{ 'translation:signIn' | i18nextCap }}</a>
      </p>
    </div>
  } @else {
    <header>
      <h2>{{ 'translation:requestPassword' | i18nextCap }}</h2>
      <p>{{ 'translation:requestPasswordText' | i18nextCap }}</p>
    </header>
    <p>
      <a routerLink="/login">{{ 'translation:signIn' | i18nextCap }}</a>
    </p>
  }
</form>
